import { AuthType, AUTHENTICATION_PROVIDER, } from '@innovyze/stylovyze/lib/types';
export const getAuthenticationProvider = () => {
    if (localStorage.getItem(AUTHENTICATION_PROVIDER) === AuthType.Forge)
        return AuthType.Forge;
    return AuthType.Auth0;
};
